import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll () {
    return store.dispatch('checkResponseApi', await Api().get('taxes'))
  },

  async getSingle (data) {
    let param = 'tax_id=' + data.tax_id
    return store.dispatch('checkResponseApi', await Api().get('tax?' + param))
  },

  async insert (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('tax', data, options))
  },

  async update (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('tax', data, options))
  },

  async delete (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete('tax', { data: data }, options))
  },

  async getGroupNames () {
    return store.dispatch('checkResponseApi', await Api().get('taxes/group_names'))
  },

}



// WEBPACK FOOTER //
// ./src/api/TaxService.js